import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import SalesCatering from "../../../assets/img/Featured/laptop-catering.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const OfficesPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page officesPage">
            <Header />
            <div className="page-header">Healthcare Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Offices</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    When it's hard to get away from the office for 
                    lunch, medical professionals, administrative 
                    staff, and management can order food and 
                    beverages with our mobile ordering solution 
                    and conveniently pick up their orders or have 
                    them delivered.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Offices", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={IGOnDemand} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default OfficesPage;